import type { RouteObject } from 'react-router';
import { PoliciesPage } from './pages/policies-page';
import { PolicyEditorPage } from './pages/policy-editor-page';

export const policiesRoutes: RouteObject[] = [
  { path: 'policies', element: <PoliciesPage /> },
  { path: 'policies/:policyId', element: <PolicyEditorPage /> },
];
